import Head from 'next/head';
import PrivacyPolicy from '@/components/privacypolicy/privacypolicy';
import { useEffect } from 'react';
import { getGuestLogDetailsApi } from '@/components/action/easycampus';


export default function PrivacyPolicyPage() {

  useEffect(() => {
    handleGestLogUserData();

  }, []);

  const handleGestLogUserData = async () => {
    try {
      let data = {
        pageName:"Faq's"
      }
      
      const res = await getGuestLogDetailsApi(data);
      return;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
       <Head>
      <title>Privacy Policy : Privacy Policy</title>
      <meta property="og:type" content="website"/>
      <meta name="description" content={"Easycampus"}/>
     <meta property="og:title" content={"Privacy Policy: Easycampus Privacy Policy"}/>
      <meta name="description" content={"Privacy Policy : Easycampus Privacy Policy"}/>
      <meta name="keywords" content={"Easycampus"}/>
      <meta property="og:url" content={"www.easycampus.in"}/>
      <meta property="og:description" content={"Privacy Policy : Easycampus Privacy Policy"}/>
      <meta property="og:image" content={'https://ec-images.s3.ap-south-1.amazonaws.com/easycampus-logo-for-video.png'}/>
    </Head> 
      <main className="flex min-h-screen flex-col">
          <div className="w-full mx-auto">
            <PrivacyPolicy/>
          </div>
        </main>
    </>
  );
}
